export default __webpack_public_path__ + "static/media/ic_arrow_left.57e21dbc.svg";